import { Fragment } from 'react';
import cx from 'classnames';
import ReactTooltip from 'react-tooltip';

import styles from '../../styles/tooltip.scss';

interface Props {
  info: string;
  place?: 'top' | 'right' | 'bottom' | 'left';
  id?: string;
}

const Tooltip = ({ info, place, id }: Props) => (
  <Fragment>
    <span
      data-tip={info}
      data-for={id || ''}
      data-place={place}
      className={cx(
        styles.tooltip,
        'text--xsm font--bold inline-block font--white text-center'
      )}
    >
      {' '}
      i{' '}
    </span>
    <ReactTooltip id={id} place={place} effect="solid" />
  </Fragment>
);

export default Tooltip;



// WEBPACK FOOTER //
// ./components/ui/tooltip.tsx